export enum TipoPago {
  WALLET = 'WALLET',
  TRANSFERENCIA = 'TRANSFERENCIA'

}
